import { render, staticRenderFns } from "./PageRestaurantsUpdate.vue?vue&type=template&id=7b2a13b0&scoped=true&"
import script from "./PageRestaurantsUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageRestaurantsUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageRestaurantsUpdate.vue?vue&type=style&index=0&id=7b2a13b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a13b0",
  null
  
)

export default component.exports